<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>DANH SÁCH TIỂU MỤC TICKET</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          v-if="canCreateAndEdit('CNPS_TICKET_SUB_CATEGORY_CREATE_UPDATE')"
          @click="create('ticket-sub-category')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i><span>&nbsp;</span>Thêm mới
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(service)="data">
                <p>{{ data.item.productRes.name }}</p>
              </template>
              <template #cell(codeGroup)="data">
                <p>{{ data.item.groupRes.code }}</p>
              </template>
              <template #cell(codeCategory)="data">
                <p>{{ data.item.categoryRes.code }}</p>
              </template>
              <template #cell(codeSubCategory)="data">
                <p>{{ data.item.code }}</p>
              </template>
              <template #cell(name)="data">
                <p>{{ data.item.name }}</p>
              </template>
              <template #cell(note)="data">
                <p>{{ data.item.description }}</p>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    v-if="canCreateAndEdit('CNPS_TICKET_SUB_CATEGORY_CREATE_UPDATE')"
                    @click="edit('ticket-sub-category', data.item.id)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Sửa
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.pageIndex"
            :total-rows="pagination.total"
            :per-page="search.pageSize"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { TicketService } from '@/services/ticket.service'
  import mxItemAction from '../mx-item-action.js'
  import { mapGetters } from 'vuex'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'service', label: 'Dịch vụ', thStyle: 'min-width: 170px' },
    { key: 'codeGroup', label: 'Mã nhóm', thStyle: 'min-width: 250px' },
    { key: 'codeCategory', label: 'Mã danh mục', thStyle: 'min-width: 150px' },
    { key: 'codeSubCategory', label: 'Mã tiểu mục', thStyle: 'min-width: 150px' },
    { key: 'name', label: 'Tên tiểu mục', thStyle: 'min-width: 150px' },
    { key: 'note', label: 'Mô tả', thStyle: 'min-width: 150px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'ticket-sub-category',
    data() {
      return {
        fieldsTable,
        filterTable: fieldsTable,
        tbLoading: false,
        lists: [],
        pagination: {
          total: 0,
        },
        search: {
          pageSize: 20,
          pageIndex: 1,
        },
      }
    },
    mixins: [mxItemAction],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    created() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        try {
          this.tbLoading = true
          const response = await TicketService.fetchSubCategory()
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.meta.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
    },
  }
</script>

<style></style>
